import { ApolloClient, gql } from '@apollo/client'
import { GraphQLContext } from '@moonpig/web-core-graphql'

type UserEmailQuery = {
  me: {
    customer: {
      email: string
    }
  }
}

const userEmailQuery = gql`
  query LastLoginUserEmailQuery {
    me {
      __typename
      customer {
        __typename
        email
      }
    }
  }
`

export const queryUserEmail = async (
  query: ApolloClient<GraphQLContext>['query'],
): Promise<string | null> => {
  try {
    const result = await query<UserEmailQuery>({
      query: userEmailQuery,
      errorPolicy: 'all',
    })

    const { data, errors } = result

    if (errors && errors.length) {
      return null
    }

    return data?.me?.customer?.email ?? null
  } catch {
    return null
  }
}
